import getTheme from "./getTheme";

const Theme = {
    getTheme,
};

export default Theme;
